module.exports = "/_next/static/images/selfie-5b0bd2e3be047bf91d689ac5b5471044.jpg";